<div *ngIf="!header.field?.startsWith('c_')">
    {{ data[header.field] | formatPrice }}
</div>
<div class="edit_cells" *ngIf="header.field?.startsWith('c_') && readOnlyMode">
    <span *ngIf="header.displayFormat === 'currency'">
      {{ data[header.field] | formatPrice }}
    </span>
    <span *ngIf="header.displayFormat !== 'currency'">
      {{ data[header.field] }}
    </span>
    <span class="trend-container">
      <span
        [ngClass]="data[header.field] | getChangeDirection:data[header.field.slice(2)]">{{data[header.field]
        | getChangePercent:data[header.field.slice(2)]}}
        <span class="negative-icon"><mat-icon>arrow_drop_down</mat-icon></span>
        <span class="postive-icon"><mat-icon>arrow_drop_up</mat-icon></span>
      </span>
    </span>
  </div>
  <div class="edit_cells" *ngIf="header.field?.startsWith('c_') && !readOnlyMode">

    <input type="text" class="edit-input" [value]="data[header.field]"
      [ngClass]="{'edited-cell': data._editedFields?.[header.field]}"
      (input)="onCellEdit($event, header.field, data)" (focus)="selectText($event)" />
    <mat-icon class="input-edit-icon">edit</mat-icon>
    <span class="trend-container">
      <span
        [ngClass]="data[header.field] | getChangeDirection:data[header.field.slice(2)]">{{data[header.field]
        | getChangePercent:data[header.field.slice(2)]}}
        <span class="negative-icon"><mat-icon>arrow_drop_down</mat-icon></span>
        <span class="postive-icon"><mat-icon>arrow_drop_up</mat-icon></span>
      </span>
    </span>
  </div>